export const routesRaporIkIzin = [
  {
    path: "/rapor_ik_izin",
    name: "rapor_ik_izin",
    component: () => import("@/views/personel/rapor_ik_izin/index.vue"),
    meta: {
      public: false,
      title: "personel.İzin Rapor",
      yetki: { k: [1014102] },
    },
  },
]
